import React from "react";
import { FaEye, FaEyeSlash, FaExclamationCircle } from "react-icons/fa";
import PropTypes from "prop-types";
import { loginTexts } from "../../locales/en";

const PasswordField = ({
  value,
  show,
  error,
  onChange,
  onToggle,
  disabled,
  label
}) => (
  <div className="input-row">
    <div className="input-group">
      <label htmlFor="password">{label}</label>

      <div className="passowrd-show">
        <input
          id="password"
          name="password"
          type={show ? loginTexts.typeText : loginTexts.passwordPlaceholder}
          placeholder={loginTexts.passwordMask}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          autoComplete="current-password"
          aria-invalid={Array.isArray(error) && error.length > 0}
        />

        <button type="button" className="password-icon" onClick={onToggle}>
          {show ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>

      {Array.isArray(error) &&
        error.map((msg, index) => (
          <p key={index} className="error-message mb-0">
            <FaExclamationCircle className="error-icon" aria-hidden />
            <small>{msg}</small>
          </p>
        ))}
    </div>
  </div>
);

export default PasswordField;

PasswordField.propTypes = {
  value: PropTypes.string,
  show: PropTypes.bool,
  error: PropTypes.any,
  onChange: PropTypes.func,
  onToggle: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string
};
